import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService'
import React from 'react'
import './DiscountTag.scss'
import FlexView from 'react-flexview/lib'

import { ReactComponent as PriceTagSvg } from '../../assets/discounts_tag.svg'
import classNames from 'classnames'
import { BillingPeriod } from '../../models/insurance-models/InsuranceBillingPeriodModel'

export const DiscountTag = props => {
  return (
    <FlexView
      className={classNames('discount-container margin-top-small', { 'annual-tag-cont': props.value == BillingPeriod.ANNUAL })}
      vAlignContent={'center'}
    >
      <FlexView vAlignContent={'center'} className={classNames('text-tiny bold', { blue: props.value != BillingPeriod.ANNUAL })}>
        <PriceTagSvg
          className={classNames(
            'margin-right-6 poppins-regular bold',
            { 'blue-svg-stroke': props.value != BillingPeriod.ANNUAL },
            { 'green-svg-stroke': props.value == BillingPeriod.ANNUAL }
          )}
        />{' '}
        {props.discountPercent ? '%' : ''} {props.title} Discount
      </FlexView>
      <div className={classNames('text-tiny bold textcenter', { blue: props.value != BillingPeriod.ANNUAL })}>
        -{FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
        {props.discountPrice}
      </div>
    </FlexView>
  )
}

export const LimitedDiscountTag = props => {
  return (
    <FlexView
      className={classNames('select-discount-container margin-top-small', { 'annual-tag-cont': props.value == BillingPeriod.ANNUAL })}
      vAlignContent={'center'}
    >
      <FlexView vAlignContent={'center'} className={classNames('text-tiny', { blue: props.value != BillingPeriod.ANNUAL })}>
        <PriceTagSvg
          className={classNames(
            'margin-right-6 poppins-regular',
            { 'blue-svg-stroke': props.value != BillingPeriod.ANNUAL },
            { 'green-svg-stroke': props.value == BillingPeriod.ANNUAL }
          )}
        />
        <div className={classNames('text-tiny bold textcenter', { blue: props.value != BillingPeriod.ANNUAL })}>
          {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
          {props.discountPrice} off
        </div>
      </FlexView>
    </FlexView>
  )
}
